import { styled } from "@mui/material"

export const Grid = styled("div")({
  display: "grid"
})